import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Zap } from "lucide-react";
import { LOGO_URL, CONTACT, NAV_LINKS, SERVICES } from "../data/site";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-zinc-950 text-white pt-24 border-t-4 border-[#E62117]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-16">
          <div className="md:col-span-4">
            <img src={LOGO_URL} alt="Andstel Group" className="h-14 w-auto bg-white p-2 inline-block" />
            <p className="mt-6 text-zinc-400 leading-relaxed max-w-sm">
              Melbourne's confident choice for electrical, solar and battery.
              Licensed, insured and Australian-owned.
            </p>
            <p className="mt-4 font-mono-brand text-xs text-zinc-500">
              ABN {CONTACT.abn}
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-display text-2xl uppercase mb-6">Navigate</h4>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-${l.testId}`}
                    className="text-zinc-300 hover:text-[#E62117] transition-colors font-medium"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-display text-2xl uppercase mb-6">Services</h4>
            <ul className="space-y-3">
              {SERVICES.slice(0, 5).map((s) => (
                <li key={s.slug}>
                  <Link
                    to="/services"
                    className="text-zinc-300 hover:text-[#E62117] transition-colors font-medium text-sm"
                  >
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-display text-2xl uppercase mb-6">Contact</h4>
            <ul className="space-y-4 text-sm">
              <li>
                <a
                  href={`tel:${CONTACT.phoneRaw}`}
                  data-testid="footer-phone"
                  className="flex items-start gap-3 text-zinc-300 hover:text-[#E62117]"
                >
                  <Phone size={16} className="mt-0.5 flex-shrink-0" />
                  <span>{CONTACT.phone}</span>
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${CONTACT.email}`}
                  data-testid="footer-email"
                  className="flex items-start gap-3 text-zinc-300 hover:text-[#E62117] break-all"
                >
                  <Mail size={16} className="mt-0.5 flex-shrink-0" />
                  <span>{CONTACT.email}</span>
                </a>
              </li>
              <li className="flex items-start gap-3 text-zinc-300">
                <MapPin size={16} className="mt-0.5 flex-shrink-0" />
                <span>{CONTACT.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-zinc-800 py-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-zinc-500 font-mono-brand uppercase tracking-wider">
            © {new Date().getFullYear()} Andstel Group — All rights reserved
          </p>
          <div className="flex items-center gap-2 text-[#E62117]">
            <Zap size={14} />
            <span className="text-xs font-mono-brand uppercase tracking-widest">
              Powering Melbourne
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
